import { render, staticRenderFns } from "./testTab.vue?vue&type=template&id=aedc5b0a&scoped=true"
import script from "./testTab.vue?vue&type=script&setup=true&lang=js"
export * from "./testTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedc5b0a",
  null
  
)

export default component.exports